import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import { connect } from 'react-redux';
import { browserHistory as history } from 'react-router';

import Accordion from '@zacousticrepo/grommet-v1-custom/components/Accordion';
import AccordionPanel from '@zacousticrepo/grommet-v1-custom/components/AccordionPanel';
import Anchor from '@zacousticrepo/grommet-v1-custom/components/Anchor';
import Box from '@zacousticrepo/grommet-v1-custom/components/Box';
import Header from '@zacousticrepo/grommet-v1-custom/components/Header';
import Footer from '@zacousticrepo/grommet-v1-custom/components/Footer';
import Menu from '@zacousticrepo/grommet-v1-custom/components/Menu';
import Sidebar from '@zacousticrepo/grommet-v1-custom/components/Sidebar';
import ToolTip from 'react-portal-tooltip';

import AssignmentIcon from '@material-ui/icons/Assignment';
import Poll from '@material-ui/icons/Poll';
import QuestionAnswer from '@material-ui/icons/QuestionAnswer';
import GroupIcon from '@material-ui/icons/Group';
import Timeline from '@material-ui/icons/Timeline';
import SupervisorAccount from '@material-ui/icons/SupervisorAccount';
import ListAlt from '@material-ui/icons/ListAlt';
import PersonAdd from '@material-ui/icons/PersonAdd';
import GroupsIcon from '@material-ui/icons/GroupAdd';

import SessionMenu from './SessionMenu';
import { navActivate } from '../navActions';
import { checkPrivledges, checkSetting } from '../utils';
import routes from '../routes';

class NavSidebar extends Component {
    constructor() {
        super();
        this._onClose = this._onClose.bind(this);
        this.showTooltip = this.showTooltip.bind(this);
        this.hideTooltip = this.hideTooltip.bind(this);
        this.showAlertsTooltip = this.showAlertsTooltip.bind(this);
        this.hideAlertsTooltip = this.hideAlertsTooltip.bind(this);
        this.openAccordChild = this.openAccordChild.bind(this);
        this.state = {
            isSupportTooltipActive: false,
            isAlertsTooltipActive: false,
            //currentNavItem: 'Jibe Dashboard'
        };
    }

    componentDidMount() {
        const location = window.location.href;
        if (location.toLowerCase().includes('surveyactivity')) {
            this.setState({ currentNavItem: 'Survey Activity' });
        }
        else if (location.toLowerCase().includes('qualityassurance')) {
            this.setState({ currentNavItem: 'QA: JibeIQ' });
        }
        else if (location.toLowerCase().includes('jibe')) {
            this.setState({ currentNavItem: 'Jibe Dashboard' });
        }
        else if (location.toLowerCase().includes('systemdashboard')) {
            this.setState({ currentNavItem: 'System Dashboard' });
        }
        else if (location.toLowerCase().includes('TeamDashboard')) {
            this.setState({ currentNavItem: 'Team Dashboard' });
        }
        else if (location.toLowerCase().includes('admin/users')) {
            this.setState({ currentNavItem: 'Users' });
        }
        else if (location.toLowerCase().includes('admin/teams')) {
            this.setState({ currentNavItem: 'Teams' });
        }
        else if (location.toLowerCase().includes('admin/surveys')) {
            this.setState({ currentNavItem: 'Surveys' });
        }
        else if (location.toLowerCase().includes('agentsurvey')) {
            this.setState({ currentNavItem: 'AgentSurvey' });
        }
        else if (location.toLowerCase().includes('coaching')) {
            this.setState({ currentNavItem: 'Coaching' });
        }
        //
    }

    setCurrentNavItem(label) {
        this.setState({ currentNavItem: label });
    }

    _onClose() {
        this.props.dispatch(navActivate(false));
    }

    _getLinks(currentUser, currentClient, routeTree, indexComponent, routePrefix, classes) {
        routePrefix = routePrefix || '';
        const links = routeTree
            .filter(
                o =>
                    !o.hideInNav &&
                    checkPrivledges(currentUser, o.roles, o.isZacousticOnly) &&
                    checkSetting(currentClient, o.settingKey)
            )
            .map(route => {
                let icon;
                switch (route.path.toLowerCase()) {
                    case "livesurveys":
                        icon = <Poll />;
                        break;
                    case "agentsurvey":
                        icon = <AssignmentIcon />;
                        break;
                    case "qualityassurance":
                        icon = <AssignmentIcon />;
                        break;
                    case "coaching":
                        icon = <AssignmentIcon />;
                        break;
                    case "surveyactivity":
                        icon = <Poll />;
                        break;
                    case "admin":
                        icon = <SupervisorAccount />;
                        break;
                    case "jibe":
                        icon = <QuestionAnswer />;
                        break;
                    case "systemdashboard":
                        icon = <Timeline />;
                        break;
                    case "teamdashboard":
                        icon = <GroupIcon />;
                        break;
                    case "surveys(/:routeUserId)":
                        icon = <ListAlt />;
                        break;
                    case "teams(/:routeTeamId)":
                        icon = <GroupsIcon />;
                        break;
                    case "users(/:routeUserId)":
                        icon = <PersonAdd />;
                        break;
                    default:
                        break;
                }
                const path = `${routePrefix}/${route.staticPath || route.path}`;
                const style = { width: '100%' };
                const itemClass = route.label === this.state.currentNavItem ? " nav-item selected-nav-item" : "nav-item";
                //classes === 'secondary' ? { borderBottom: 'none', width: '100%' } : {};
                const item =
                    route.notificationSource &&
                        this.props[route.notificationSource] &&
                        this.props[route.notificationSource].length ? (
                        <Anchor
                            key={route.label}
                            path={{ path, isDefault: indexComponent === route.component }}
                            className={classes}>
                            <Box
                                style={{ overflow: 'hidden' }}
                                flex={true}
                                direction="row"
                                justify="between"
                                responsive={false}>
                                <span className="">{route.label}</span>
                            </Box>
                        </Anchor>
                    ) : (
                        <div className={itemClass} key={route.label} >
                            <div className="nav-icon" >
                                {icon}
                            </div>
                            <Anchor
                                onClick={() => this.setCurrentNavItem(route.label)}
                                key={route.label}
                                path={{ path, isDefault: indexComponent === route.component }}
                                style={style}
                                label={route.label}
                                className={classes}
                            />
                        </div>
                    );

                const children = route.childRoutes
                    ? this._getLinks(currentUser, currentClient, route.childRoutes, indexComponent, path, 'secondary')
                    : [];

                if (children.length < 2) {
                    return item;
                } else {
                    const accordNode = (
                        <div className="nav-item">
                            <div className="nav-icon">
                                {icon}
                            </div>
                            <span>{route.label}</span>
                        </div>
                    );
                    return (
                        <Accordion onActive={a => this.openAccordChild(a, route)} id="accord" key={route.label}>
                            <AccordionPanel key={route.label} heading={accordNode}>
                                {children}
                            </AccordionPanel>
                        </Accordion>
                    );
                }
            });
        return links;
    }

    openAccordChild(a, accord) {
        switch (accord.path) {
            case undefined:
                break;
            case 'admin':
                this.setState({ currentNavItem: 'Users' });
                history.push('/admin/users');
                break;
        }
    }

    showTooltip() {
        this.setState({ isSupportTooltipActive: true });
    }

    hideTooltip() {
        this.setState({
            isSupportTooltipActive: false
        });
    }

    showAlertsTooltip() {
        this.setState({ isAlertsTooltipActive: true });
    }

    hideAlertsTooltip() {
        this.setState({
            isAlertsTooltipActive: false
        });
    }

    render() {
        const { currentUser, currentClient } = this.props;

        if (!currentUser || !currentClient) return <span />;

        const indexRouteComponent = routes[0].childRoutes[0].indexRoute.component;
        const routeTreeMain = routes[0].childRoutes[0].childRoutes;
        const links = this._getLinks(currentUser, currentClient, routeTreeMain, indexRouteComponent).filter(link => {
            return link != undefined;
        });

        const logoName = this.state.currentNavItem === 'Jibe Dashboard'
            ? `../../../../../../Assets/Images/V3Design/JibeNavBarBackgroundJibeLogo.png`
            : `../../../../../../Assets/Images/V3Design/JibeNavBarBackgroundLogo.png`;

        return (
            <Sidebar style={{
                width: '264px',
                backgroundPosition: 'top',
                height: '100vh',
                backgroundImage: `url(${logoName})`
            }}>
                <ToolTip
                    active={this.state.isAlertsTooltipActive}
                    useHover={false}
                    tooltipTimeout={50}
                    position="top"
                    arrow="center"
                    parent=".alert__menu">
                    Alerts
                </ToolTip>
                <Header size="large" justify="between" pad={{ horizontal: 'medium' }}
                    style={{
                        height: '234px',
                        margin: '30px 0',
                        backgroundSize: 'contain',
                    }}>
                </Header>
                <Menu fill={true} primary={true}>
                    {links}
                </Menu>
                {/*                 
                <Box style={{ marginLeft: '15px' }}>
                    <Label>Version: 112119.08.30</Label>
                </Box>
                 */}

                <Footer>
                    <div style={{ paddingLeft: '0px', position: 'fixed', bottom: '14px' }} >
                        <SessionMenu dropAlign={{ bottom: 'bottom' }} />
                    </div>
                </Footer>
            </Sidebar>
        );
    }
}

NavSidebar.propTypes = {
    dispatch: PropTypes.func.isRequired,
    sessionError: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    currentUser: PropTypes.object,
    currentClient: PropTypes.object
};

const select = state => ({ nav: state.nav, ...state.session });

export default connect(select)(NavSidebar);